import BaseObject from '../../../base/base_object';

export default class GamePostMessageListenerBase extends BaseObject {
    static CLASS = 'GamePostMessageListenerBase';
    _prevGameBalance = null;
    _prevDiffBalance = null;

    dispose() {}

    processPostMessage(messageData) {
        this.throwNotImplemented('11', 'processPostMessage');
    }
}